<!--
 * @Date: 2022-03-10 21:21:05
 * @LastEditTime: 2022-11-08 18:05:47
 * @Description: file content
-->
<template>
  <div v-if="visible" class="pc-dialog">
    <div class="mask" />
    <div class="pc-dialog-cont-wrap">
      <div :class="['pc-dialog-title', { bold: isNormal }]">
        {{ title }}
      </div>
      <div v-if="!isNormal" class="pc-dialog-cont">
        <ul>
          <li>
            <div class="label">通话时长</div>
            <p>{{ duration }}分钟</p>
          </li>
          <li>
            <div class="label">服务时间</div>
            <p>{{ serviceTime }}</p>
          </li>
          <li>
            <div class="label">接听手机号码</div>
            <p>{{ phone }}</p>
          </li>
        </ul>
      </div>
      <div v-if="isNormal" class="dialog-message-wrap">{{ message }}</div>
      <div class="pc-dialog-btn-wrap">
        <div v-if="isShowCancelBtn" class="pc-dialog-btn" @click="handleClose">
          修改
        </div>
        <div class="pc-dialog-btn comfirm" @click="handleSubmit">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import { doPoint } from '@/utils/index';

export default {
  props: {
    title: {
      type: String,
      default: '信息确认',
    },
    isNormal: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    phone: {
      type: String,
      default: '',
    },
    isShowCancelBtn: {
      type: Boolean,
      default: true,
    },
    duration: {
      type: Number,
      default: 20,
    },
    serviceTime: {
      type: String,
      default: '9:00-21:00',
    },
  },
  watch: {
    // 解决滑动穿透问题
    visible: {
      immediate: true,
      deep: true,
      handler(val) {
        const body = document.getElementsByTagName('body')[0] || {};
        if (val) {
          body.style.overflow = 'hidden';
        } else {
          body.style.overflow = 'visible';
        }
      },
    },
  },
  methods: {
    handleClose() {
      doPoint('AppClick', {
        click_position: '取消',
        page_readable_name: '心理咨询热线',
      });
      this.$emit('update:visible', false);
    },
    handleSubmit() {
      this.$emit('handleSubmit');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
@mixin btn-border($border, $radius) {
  position: relative;
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border: rem(1) solid $border;
    border-radius: rem($radius);
    transform: scale(0.5);
    transform-origin: 0 0;
    content: '';
  }
}
.pc-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }
  .pc-dialog-cont-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    width: rem(280);
    background: #fff;
    border-radius: rem(4);
    transform: translate(-50%, -50%);
  }
  .pc-dialog-title {
    padding: rem(24) 0 rem(15);
    color: #1a1a1a;
    font-size: rem(18);
    line-height: rem(18);
    text-align: center;
    &.bold {
      font-weight: bold;
    }
  }
  .pc-dialog-cont {
    padding: 0 rem(26);
    li {
      display: flex;
      align-items: center;
      height: rem(48);
      font-size: rem(15);
      line-height: rem(17);
      @include border-bottom-1px(#e7e7e7);
      &:last-child {
        &::after {
          content: none;
        }
      }
      p {
        margin: 0;
        color: #323232;
      }
    }
    .label {
      margin-right: rem(15);
      color: #666;
    }
  }
  .dialog-message-wrap {
    padding: rem(10) rem(26) 0;
    line-height: 1.3;
  }
  .pc-dialog-btn-wrap {
    display: flex;
    justify-content: center;
    padding: rem(25) rem(15) rem(15);
    .pc-dialog-btn {
      flex-basis: rem(120);
      flex-grow: 0;
      flex-shrink: 0;
      box-sizing: border-box;
      width: rem(120);
      height: rem(44);
      margin-right: rem(10);
      color: #323232;
      line-height: rem(44);
      text-align: center;
      background: #fff;
      border-radius: rem(50);
      @include btn-border(#e7e7e7, 100);
      &:last-child {
        margin-right: 0;
      }
      &.comfirm {
        color: #fff;
        background: #39d167;
        &::before {
          content: none;
        }
      }
    }
  }
}
</style>
